import { render, staticRenderFns } from "./modalCapNhatNhomChucVu.vue?vue&type=template&id=fa23a1b0&"
import script from "./modalCapNhatNhomChucVu.vue?vue&type=script&lang=js&"
export * from "./modalCapNhatNhomChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports